import { businessBaseURL } from "./base";
var baseURL = "".concat(businessBaseURL, "/owner");
export var owner = {
    home: function () { return baseURL; },
    playlists: {
        index: function (type) {
            return "".concat(baseURL, "/playlists/").concat(type);
        },
        view: function (id) { return "".concat(baseURL, "/playlists/public/").concat(id); },
        edit: function (id) { return "".concat(baseURL, "/playlists/private/").concat(id, "/edit"); },
    },
    devices: {
        index: function () { return "".concat(baseURL, "/devices"); },
        settings: function (id) { return "".concat(baseURL, "/devices/").concat(id, "/settings"); },
    },
    timetables: {
        index: function () { return "".concat(baseURL, "/timetables"); },
        edit: function (id) { return "".concat(baseURL, "/timetables/").concat(id, "/edit"); },
    },
    programs: {
        index: function () { return "".concat(baseURL, "/programs"); },
        edit: function (id) { return "".concat(baseURL, "/programs/").concat(id, "/edit"); },
    },
    files: {
        index: function () { return "".concat(baseURL, "/files"); },
    },
};
